import React from 'react'
import { List } from '../../event/components'
import data from '../../event/data'
import { SearchInput } from '../../../components'

const ListEvent = () => {
  return (
    <div>
      <div className="w-full xl:w-6/12 mb-5 lg:mb-10">
        <SearchInput />
      </div>
      <List data={data} bookmark={true} uniform/>
    </div>
  )
}

export { ListEvent }
